export default `
  mutation resendInvite($email: String!) {
    resendInvite(email: $email) {
      id
      email
      resent
      emailSent
    }
  }
`
